<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="Microsoft Peering向けNAPT情報"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <div>
            <v-container>
              <v-row>
                <v-col class="d-flex flex-row justify-end">
                  <v-btn
                    color="primary"
                    @click="modifyNaptSetting"
                    v-permission.config
                    >設定</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="VPN/VNコード"
                    :value="naptSetting.vpnVnCode"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group label="NAPT用グローバルIP">
                    <template #value>
                      <div class="ml-3">
                        <span>
                          現在 {{ naptSetting.usedNapt }}個 / 上限
                          {{ naptSetting.upperLimitNapt }}個
                        </span>
                        <div class="ml-3">
                          <div>グローバルIP</div>
                          <div v-if="naptSetting.usedNapt !== 0">
                            <div
                              v-for="(
                                item, index
                              ) in naptSetting.msNaptGlobalIpList"
                              :key="index"
                            >
                              <span class="pl-3">{{
                                item.globalIpAddress
                              }}</span>
                            </div>
                          </div>
                          <div v-else class="pl-3">-</div>
                        </div>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { NatNaptDetailEntity } from "@/apis/MSPeeringIpApi";
import { VueFinalModal } from "vue-final-modal";
import MSNaptSettingModify from "@/modals/msNaptSetting/MSNaptSettingModify.vue";

export default defineComponent({
  name: "MSNaptSettingReference",
  props: {
    /** 設定変更時、使用する排他キー */
    keyId: {
      type: String as PropType<string>,
      required: true,
    },
    /** NAPT用グローバルIP設定情報 */
    naptSetting: {
      type: Object as PropType<NatNaptDetailEntity>,
      required: true,
    },
  },
  methods: {
    /** NAPT用グローバルIPの追加・削除 */
    async modifyNaptSetting() {
      await this.$modal.show(MSNaptSettingModify, {
        keyId: this.keyId,
        naptSetting: this.naptSetting,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
